export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Warantyicon.0dedfb68.svg","height":39,"width":43,"blurWidth":0,"blurHeight":0};